import React from "react";
import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import { useSelector } from "react-redux";
import {
  useBriefMasterData,
  useCreateClinicalTrial,
} from "../../containers/ClinicalTrials/Hooks";
import { BriefForm } from "../../components/ClinicalTrials/Brief";
import { useStudyRoles } from "../../containers/Security/Authorization/useStudyRoles";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { getClinicalTrialBriefSchema } from "../../components/Validations/FormValidationSchema";
import { HandleApiError } from "../../components/Notifications/APIErrorHandler";

export const ClinicalTrialsCreateBriefContainer = () => {
  const { t } = useTranslation();
  let history = useHistory();
  const masterData = useBriefMasterData();
  const currentUser = useSelector((state) => state.authentication.user);

  const [createTrial] = useCreateClinicalTrial();
  const [studyRoles] = useStudyRoles();

  const handleSubmit = async (values, formikBag) => {
    try {
      const { brief } = values;

      values.brief.studyRoles.permissions = null;

      if (values.brief.currentUserStudyRole) {
        values.brief.currentUserStudyRole.permissions = null;
      }

      const payload = {
        title: brief.title,
        fullTitle: brief.fullTitle,
        protocolNumber: brief.protocolNumber,
        centerNumber: brief.centerNumber,
        sponsor: brief.laboratory?.label ?? brief.laboratory,
        ntc: brief.formNTC,
        eudraTc: brief.eudraTC,
        principalInvestigator: brief.principalInvestigator,
        indications: brief.indication ? [brief.indication] : [],
        subIndications: brief.subIndications ? brief.subIndications : [],
        prescriptionCodes: Array.isArray(brief.keywords)
          ? brief.keywords.map((k) => ({
              conceptId: k.conceptId,
              description: k.description,
            }))
          : [],
        specialty: brief.specialty ? [brief.specialty] : [],
        version: brief.version,
        studyRoles: brief.studyRoles,
        currentUserStudyRole: brief.currentUserStudyRole,
        currentUserResponsability: brief.currentUserResponsability?.value,
        phase: brief.phase,
      };

      const result = await createTrial(payload);

      if (result && !result.Error) {
        if (result.warnings?.length) {
          result.warnings.forEach((warning) => {
            toast.warning(t(warning));
          });
        }

        history.push(`/admin/clinicalTrials`);
      }
      // Si result es null, el error ya se mostró con HandleApiError en useCreateClinicalTrial
    } catch (err) {
      HandleApiError(err);
    } finally {
      formikBag.setSubmitting(false);
    }
  };

  const handleCancel = () => {
    history.push(`/admin/clinicalTrials`);
  };

  return (
    <Formik
      initialValues={{ brief: {} }}
      validationSchema={getClinicalTrialBriefSchema(currentUser?.sub)}
      onSubmit={handleSubmit}
    >
      {(props) => (
        <BriefForm
          {...props}
          onCancel={handleCancel}
          masterData={masterData}
          studyRoles={studyRoles}
        />
      )}
    </Formik>
  );
};
